import { ConditionalWrapper } from '@presentation/utils';
import type { LocationDescriptor } from 'history';
import type { FC } from 'react';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Loading } from '../Loading';
import * as Styled from './styled';
import type { ButtonProps } from './types';

export * from './types';

export const Button: FC<ButtonProps> = (props) => {
  const {
    size = 'medium',
    shadow = false,
    squared = false,
    loading = false,
    loadingProps = {
      color: 'light',
      type: 'spinning-circles',
    },
    shrink = false,
    color = 'light',
    disabled = false,
    onClick,
    outlined = false,
    iconLeft,
    iconRight,
    children,
    type = 'button',
    link,
    linkWrapperProps,
    externalLink,
    externalLinkWrapperProps,
    breakSpaces = false,
    ...rest
  } = props;

  const clickHandler = useCallback(
    (event: MouseEvent) => {
      if (disabled) return;
      onClick?.(event as any);
    },
    [disabled, onClick],
  );
  return (
    <ConditionalWrapper
      condition={!!link || !!externalLink}
      wrapper={(wrapperChildren) => (
        <>
          {link && (
            <Link to={link as LocationDescriptor} {...linkWrapperProps}>
              {wrapperChildren}
            </Link>
          )}
          {externalLink && (
            // eslint-disable-next-line react/jsx-no-target-blank
            <a href={externalLink} target="_blank" {...externalLinkWrapperProps}>
              {wrapperChildren}
            </a>
          )}
        </>
      )}
    >
      <Styled.ButtonItem
        {...{ size, shadow, squared, shrink, color, disabled, outlined, breakSpaces }}
        {...rest}
        disabled={disabled || loading}
        type={type}
        onClick={clickHandler as any}
      >
        {!!iconLeft && <Styled.IconWrapper position="left">{iconLeft}</Styled.IconWrapper>}
        {children}
        {!!iconRight && <Styled.IconWrapper position="right">{iconRight}</Styled.IconWrapper>}
        {!!loading && <Loading {...loadingProps} css={Styled.buttonLoadingStyle} />}
      </Styled.ButtonItem>
    </ConditionalWrapper>
  );
};
